import { LoadingOutlined } from "@ant-design/icons";
import { useEffect } from "react";
import { Footer, Header, Overlay, SubRouteLayout } from "../layouts";
import CartFloatingBar from "../layouts/cart/floatingBar";
import { Flex, Text } from "../components";
import { useAuth, useApp } from "../hooks";
import { useMenuStore } from "../stores";
import {
  Routes as RRDRoutes,
  Navigate,
  Route,
  Outlet,
} from "react-router-dom";
import {
  TrackOrder,
  Addresses,
  Favorites,
  Checkout,
  Profile,
  Orders,
  Menu,
  Terms,
  Privacy,
  Refund,
} from "../pages";

const StorefrontLayout = () => {
  const loadMenu = useMenuStore((state) => state.load);

  useEffect(() => {
    loadMenu();
  }, [loadMenu]);

  return (
    <>
      <Header />
      <Outlet />
      <Footer />
      <CartFloatingBar />
      <Overlay />
    </>
  );
};

const Routes = () => {
  const { isAuthenticated } = useAuth();
  const { isReady } = useApp();

  if (!isReady)
    return (
      <Flex justify="center" align="center" style={{ height: "100vh" }}>
        <Text type="base" size={"15rem"}>
          <LoadingOutlined />
        </Text>
      </Flex>
    );

  return (
    <RRDRoutes>
      <Route element={<StorefrontLayout />}>
        <Route path="/" element={<Menu />} />
        <Route element={<SubRouteLayout />}>
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/orders/:id" element={<TrackOrder />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy-policy" element={<Privacy />} />
          <Route path="/refund-policy" element={<Refund />} />
          {isAuthenticated && (
            <>
              <Route path="/orders" element={<Orders />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/favorites" element={<Favorites />} />
              <Route path="/addresses" element={<Addresses />} />
            </>
          )}
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </RRDRoutes>
  );
};

export default Routes;
